module.exports = __webpack_public_path__ + "static/media/store-level-1.74d7acb3.png";